import Pagination from "./Pagination";
import React, { useEffect, useState, useMemo } from "react";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import Badge from "./Badge";
import Select from "./Select";
import { Link } from "react-router-dom";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx"; // Libreria per l'esportazione Excel

const ListPaymentsOperator = (props) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentItems, setCurrentItems] = useState([]);
  const [orderBy, setOrderBy] = useState(null);

  const sortPayments = (payments, orderBy) => {
    const clonedPayments = [...payments]; // Clona l'array per evitare mutazioni
    switch (orderBy) {
      case "amount-asc":
        return clonedPayments.sort((a, b) => a.importoTotale - b.importoTotale); // Ordina per importo crescente
      case "amount-desc":
        return clonedPayments.sort((a, b) => b.importoTotale - a.importoTotale); // Ordina per importo decrescente
      case "name-asc":
        return clonedPayments.sort(
          (a, b) =>
            a.cognome.localeCompare(b.cognome) || a.nome.localeCompare(b.nome),
        ); // Ordina per cognome e nome crescente
      case "name-desc":
        return clonedPayments.sort(
          (a, b) =>
            b.cognome.localeCompare(a.cognome) || b.nome.localeCompare(a.nome),
        ); // Ordina per cognome e nome decrescente
      default:
        return clonedPayments; // Nessun ordinamento
    }
  };

  const sortedPayments = useMemo(() => {
    return props.paymentsTemp ? sortPayments(props.paymentsTemp, orderBy) : [];
  }, [props.paymentsTemp, orderBy]);

  // Effettua la paginazione sui dati ordinati
  const HandleUpdate = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;

    if (sortedPayments && sortedPayments.length > 0) {
      setCurrentItems(sortedPayments.slice(startIndex, endIndex)); // Paginazione corretta
    } else {
    }
  };

  const getOrderLabel = (orderBy) => {
    switch (orderBy) {
      case "amount-asc":
        return "Importo da pagare crescente";
      case "amount-desc":
        return "Importo da pagare decrescente";
      case "name-asc":
        return "Cognome e Nome crescente";
      case "name-desc":
        return "Cognome e Nome decrescente";
      default:
        return "";
    }
  };

  const exportToExcel = () => {
    const selectedData = props.paymentsTemp;

    if (selectedData.length > 0) {
      const cleanedData = selectedData.map(({ paymentIds, ...rest }) => rest);

      const today = new Date().toISOString().split("T")[0]; // Formato YYYY-MM-DD

      const nomeBando = props.nomeBando ? props.nomeBando : ""; // Verifica se esiste il nome del bando

      // Genera il nome del file in base alla presenza del nome del bando
      const fileName = nomeBando
        ? `pagamenti_${today}_${nomeBando
            .replace(" ", "-")
            .replace("/", "-")}.xlsx`
        : "pagamenti.xlsx";

      const worksheet = XLSX.utils.json_to_sheet(cleanedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Pagamenti");
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      // Salva il file
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, fileName);
    } else {
      alert("Nessun pagamento selezionato per esportare.");
    }
  };

  return (
    <>
      <div className="row mb-2">
        <div className="col-2">
          Record trovati: <strong>{props.paymentsTemp.length}</strong>
        </div>
        <div className="col-2">
          {props.paymentsTemp.length > 0
            ? `${props.paymentsTemp
                .reduce(
                  (acc, curr) => acc + parseFloat(curr.importoTotale || 0),
                  0,
                )
                .toLocaleString("it-IT", {
                  minimumFractionDigits: 2, // Sempre due decimali
                  maximumFractionDigits: 2, // Limita a due decimali
                })} €`
            : "0,00 €"}{" "}
          <strong> totali</strong>
        </div>

        <div className="col-2 d-flex align-items-center justify-content-end">
          <label>Risultati per pagina</label>
        </div>
        <div className="col-1">
          <Select
            aria-label="Record"
            defaultMenuIsOpen={false}
            required
            icon={false}
            label="Ciao"
            name="recordsPerPage"
            id="recordsPerPage"
            options={[
              { value: 10, label: "10" },
              { value: 25, label: "25" },
              { value: 50, label: "50" },
            ]}
            onChange={(selectedOption) => {
              setItemsPerPage(selectedOption.value); // Usa selectedOption.value
            }}
            value={
              itemsPerPage
                ? { value: itemsPerPage, label: itemsPerPage.toString() }
                : null
            }
            placeholder="Seleziona il numero di record"
          />
        </div>
        <div className="col-2 d-flex align-items-center justify-content-end">
          <label>Ordina risultati:</label>
        </div>
        <div className="col-3 pb-3 text-right">
          <Select
            aria-label="Ordina risultati"
            required
            name="orderBy"
            id="orderBy"
            options={[
              { value: "amount-asc", label: "Importo da pagare crescente" },
              { value: "amount-desc", label: "Importo da pagare decrescente" },
              { value: "name-asc", label: "Cognome e Nome crescente" },
              { value: "name-desc", label: "Cognome e Nome decrescente" },
            ]}
            onChange={(selectedOption) => {
              setOrderBy(selectedOption.value); // Aggiorna l'ordinamento
            }}
            value={
              orderBy ? { value: orderBy, label: getOrderLabel(orderBy) } : null
            }
            placeholder="Importo da pagare decrescente"
          />
        </div>
      </div>

      <div className="card-wrapper card-space">
        <div className="card card-bg card-big roundedCustom no-after">
          <div className="card-body">
            <div className="row">
              <div className="col-lg-3 text-center">
                <strong>Cognome Nome</strong>
              </div>
              <div className="col-lg-2 pr-4 text-center">
                <strong>Codicefiscale</strong>
              </div>
              <div className="col-lg-3 text-center">
                <strong>Contatti</strong>
              </div>
              <div className="col-lg-3 text-center">
                <div className="row">
                  <div className="col-6 p-0">
                    <strong>Importo da pagare</strong>
                  </div>
                  <div className="col-6">
                    <strong>Importo pagato</strong>
                  </div>
                </div>
              </div>
              <div className="col-lg-1 text-center"></div>
            </div>
            {currentItems && currentItems.length > 0 ? (
              currentItems.map((x, index) => (
                <div className="row mt-2" key={index}>
                  <div className="col-3  text-left">
                    {x.cognome} {x.nome}
                  </div>
                  <div
                    className="col-2 text-center pr-4"
                    style={{ fontFamily: "monospace" }}
                  >
                    {x.codiceFiscale}
                  </div>

                  <div className="col-lg-3">
                    <div>
                      <span className="fw-semibold clearfix">
                        {x.telefono ?? "N/A"}
                      </span>
                      <span className="fw-semibold">{x.email ?? "N/A"}</span>
                    </div>
                  </div>

                  <div className="col-lg-3 text-center">
                    <div className="row">
                      <div className="col-6">
                        <span className="fw-semibold text-danger">
                          <strong>
                            {x.importoTotale
                              ? `${parseFloat(x.importoTotale).toLocaleString(
                                  "it-IT",
                                  {
                                    minimumFractionDigits: 2, // Sempre due decimali
                                    maximumFractionDigits: 2, // Limita a due decimali
                                  },
                                )} €`
                              : "0,00 €"}
                          </strong>
                        </span>
                      </div>
                      <div className="col-6">
                        <span className="fw-semibold text-success">
                          <strong>
                            {x.importoPagato
                              ? `${parseFloat(x.importoPagato).toLocaleString(
                                  "it-IT",
                                  {
                                    minimumFractionDigits: 2, // Sempre due decimali
                                    maximumFractionDigits: 2, // Limita a due decimali
                                  },
                                )} €`
                              : "0,00 €"}
                          </strong>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-1 text-right">
                    <Link to={"/lista_utenti/cartella_sociale?id=" + x.userId}>
                      <button
                        className="btn btn-outline-primary p-1 ml-1 btn-block"
                        title={`${
                          x.paymentIds.split(";").length
                        } pagamenti in sospeso`}
                      >
                        <svg className="icon icon-primary">
                          <use href={`${iconSprite}#it-user`} />
                        </svg>
                        <Badge
                          badgeText={x.paymentIds.split(";").length}
                          badgeStatus={"bg-primary"}
                        />
                      </button>
                    </Link>
                  </div>
                </div>
              ))
            ) : (
              <>Non ci sono pagamenti</>
            )}

            {sortedPayments && (
              <Pagination
                items={sortedPayments}
                setCurrentItems={setCurrentItems}
                itemsPerPage={itemsPerPage}
              />
            )}
            <div className="form-group col-12 text-right mt-5">
              <button
                type="button"
                className="btn btn-primary"
                onClick={exportToExcel}
              >
                Scarica Excel
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ListPaymentsOperator;
